<div class="unsubscribe-container tds-u-p3" style="width: 600px;margin: 0 auto;">
  <tds-header>
    <tds-header-hamburger
    id="demo-hamburger"
    aria-label="Open application drawer"
    aria-haspopup="true"
    aria-expanded="false">
  </tds-header-hamburger>
  <tds-header-title>
    <tds-link>
    <a [routerLink]="landingPage" style="text-decoration: none;color: var(--tds-header-nav-item-color);">DCP CORE ASSIST</a>
    </tds-link>
  </tds-header-title>
    <tds-header-brand-symbol
      slot="end"
      placement="end">
      <a [routerLink]="landingPage"></a>
    </tds-header-brand-symbol>

  </tds-header>
  <tds-message
    variant="success"
    header="Subscription Removed"
    tds-alert-dialog="dialog"
    tds-aria-label="A Message component"
  >
    Your email has been successfully unsubscribed from future notifications.
    <br />
  </tds-message>
</div>